import { render } from "./SelectedPlanInfo.vue?vue&type=template&id=4904c9fa&scoped=true"
import script from "./SelectedPlanInfo.vue?vue&type=script&lang=js"
export * from "./SelectedPlanInfo.vue?vue&type=script&lang=js"

import "./SelectedPlanInfo.vue?vue&type=style&index=0&id=4904c9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4904c9fa"]])

export default __exports__